import { render } from "./index.vue?vue&type=template&id=074824d5&scoped=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"

import "./index.vue?vue&type=style&index=0&id=074824d5&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-074824d5"

export default script